/*
 * @Description:
 * @Autor: wangwangwang
 * @Date: 2021-01-28 09:46:13
 * @LastEditors: hexy 913752270@qq.com
 * @LastEditTime: 2026-06-22 10:24:01
 */
import axios from "axios";
import { getToken, getUserId } from "@/utils/auth";
import { Message } from "element-ui";
exports.install = function (Vue) {
  Vue.prototype.$Download = function (url, data, name) {
    //全局函数
    const loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
    });
    let baseURL = "";
    if (process.env.NODE_ENV == "development") {
      baseURL = "/dev";
    } else if (process.env.VUE_APP_API_HOST) {
      baseURL = process.env.VUE_APP_API_HOST;
    }
    axios({
      method: "post",
      url: baseURL + url, // 请求地址
      headers: {
        "access-token": getToken(),
        "user-id": getUserId(),
        "system-info" : 'icps',
      },
      data: {
        page: data.page ? data.page : 1,
        pageSize: 999999,
        ...data,
      }, // 参数
      responseType: "blob", // 表明返回服务器返回的数据类型
    }).then(res => {
      loading.close();
      // 处理请求错误
      if (res.data instanceof Blob && res.data.type === "application/json") {
        // 如果错误信息是一个 JSON 格式的 Blob，那么读取 Blob 的内容并解析为 JSON 对象
        return res.data.text().then(text => {
          const data = JSON.parse(text);
          Message({
            showClose: true,
            message: data.codeMsg,
            type: "warning",
          });
        });
      } else {
        let json = JSON.parse(JSON.stringify(res.headers)); //头部数据
        const blob = new Blob([res.data]);
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        if (url == "/base/system/user/exportTemplate") {
          link.download = "用户导入模板.xls";
        } else if (url == "/base/system/user/exportPersonalTemplate") {
          link.download = "个人用户导入模板.xls";
        } else if (url == "/base/system/user/export") {
          link.download = "用户导出.xls";
        } else if (url == "/icps/system/sign/basics/graphic/exportTemplate") {
          link.download = "浇筑部位导入模板.xls";
        } else if (url == "/base/outer/no/login/getStationWxacode") {
          link.download = `${name}.jpg`;
        } else if (url == "/icps/system/sign/intelligent/selfreport/exportReport") {
          link.download = `${name}.docx`;
        } else if (url == "/icps/system/sign/dataCollection/planPayment/exportCurrentPage") {
          link.download = "计划付款.xlsx";
        }else {
          if (name) {
            link.download = name;
          } else {
            let newName = "";
            if (/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)) {
              newName = json["content-disposition"];
            } else {
              newName = decodeURIComponent(escape(json["content-disposition"]));
            }
            link.download = newName;
          }
        }
        link.click();
        window.URL.revokeObjectURL(link.href);
      }
    });
  };
  Vue.prototype.$Download2 = function (url, data) {
    //全局函数
    const loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
    });
    let baseURL = "";
    if (process.env.NODE_ENV == "development") {
      baseURL = "/dev";
    } else if (process.env.VUE_APP_API_HOST) {
      baseURL = process.env.VUE_APP_API_HOST;
    }
    axios({
      method: "post",
      url: baseURL + url, // 请求地址
      headers: {
        "access-token": getToken(),
        "user-id": getUserId(),
        "system-info" : 'icps',
      },
      data: data, // 参数
      responseType: "blob", // 表明返回服务器返回的数据类型
    }).then(res => {
      loading.close();
      let json = JSON.parse(JSON.stringify(res.headers)); //头部数据
      const blob = new Blob([res.data]);
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      let name = "";
      if (/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)) {
        name = json["content-disposition"];
      } else {
        name = decodeURIComponent(escape(json["content-disposition"]));
      }
      link.download = name;
      link.click();
      window.URL.revokeObjectURL(link.href);
    });
  };
  Vue.prototype.$fromatTable = function (List, data, id, name) {
    for (let i = 0; i < List.length; i++) {
      if (List[i][id] === data) {
        return List[i][name];
      }
    }
    return "无数据";
  };
  Vue.prototype.$wps = function (fileUrl, waterMark) {
    let baseURL = "";
    if (process.env.NODE_ENV == "development") {
      baseURL = "/dev";
    }
    axios({
      method: "get",
      url: baseURL + "/icps/outer/sign/outerApi/wps/getViewUrlWebPath", // 请求地址
      headers: {
        "access-token": getToken(),
        "user-id": getUserId(),
        "system-info" : 'icps',
      },
      params: {
        fileUrl: fileUrl,
        waterMark: waterMark,
      }, // 参数
    }).then(res => {
      sessionStorage.wpsUrl = res.data.data;
      const jump = this.$router.resolve({ name: "wps" });
      window.open(jump.href, "_blank");
    });
  };
};
